import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoAndIconComponent } from '../info-and-icon/info-and-icon.component';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/angular-fontawesome/types';

@Component({
  selector: 'shared-chat-context-menu-option',
  standalone: true,
  imports: [CommonModule, InfoAndIconComponent],
  templateUrl: './chat-context-menu-option.component.html',
  styleUrl: './chat-context-menu-option.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatContextMenuOptionComponent {
  icon = input<IconProp>(faPlus);
  option = input<string>('Option');
  event = input<string>('');
  optionClicked = output<string>();
}
